var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWalletSquareIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 87,
    height: 87,
    viewBox: "0 0 87 87",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6450",
    "data-name": "Groupe 6450",
    transform: "translate(0 0.17)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_3503",
    "data-name": "Rectangle 3503",
    transform: "translate(0 -0.17)",
    fill: "#d9fdf9",
    stroke: "#3ac1ae",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 87,
    height: 87,
    rx: 6,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 86,
    height: 86,
    rx: 5.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5715",
    "data-name": "Trac\\xE9 5715",
    d: "M33.742,4.073H24.5V3.055A3.058,3.058,0,0,0,21.45,0H13.3A3.058,3.058,0,0,0,10.25,3.055V4.073H1.018A1.021,1.021,0,0,0,0,5.091v22.4a3.058,3.058,0,0,0,3.055,3.055H31.7a3.058,3.058,0,0,0,3.055-3.055V5.108a.989.989,0,0,0-1.012-1.035M12.286,3.055A1.019,1.019,0,0,1,13.3,2.036H21.45a1.02,1.02,0,0,1,1.018,1.018V4.073H12.286ZM32.323,6.109l-3.162,9.486a1.016,1.016,0,0,1-.965.7H22.468V15.273a1.018,1.018,0,0,0-1.018-1.018H13.3a1.018,1.018,0,0,0-1.018,1.018v1.018H6.559a1.017,1.017,0,0,1-.966-.7L2.431,6.109ZM20.432,18.327H14.323V16.291h6.109Zm12.286,9.164A1.02,1.02,0,0,1,31.7,28.509H3.055a1.02,1.02,0,0,1-1.018-1.018V11.365l1.625,4.874a3.05,3.05,0,0,0,2.9,2.089h5.728v1.018A1.018,1.018,0,0,0,13.3,20.364H21.45a1.018,1.018,0,0,0,1.018-1.018V18.327H28.2a3.05,3.05,0,0,0,2.9-2.089l1.625-4.874Z",
    transform: "translate(26.158 28.263)",
    fill: "#3ac1ae"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletSquareIcon);
export default __webpack_public_path__ + "static/media/wallet-square-icon.e5743a5062a4c0662608e6f78d9a50f2.svg";
export { ForwardRef as ReactComponent };